import { AuthModalVariant } from '@kijiji/generated/graphql-types'

/**
 * These keys must match the ModalState schema on localSchema.gql
 */
export enum MODAL_REGISTRY {
  LISTING_FINANCING = 'financing-inquiry-modal',
  REPLY_TO_SELLER = 'r2s-message-form-modal',
  VEHICLE_HISTORY_LEARN = 'vehicle-history-learn-more-modal',
  VEHICLE_HISTORY_REQUEST = 'vehicle-history-request-modal',
  PAYMENT_ESTIMATOR = 'payment-estimator-modal',
  MILEAGE_ANALYSIS_LEARN = 'mileage-analysis-modal',
  PRICE_INSIGHT_LEARN = 'price-insight-modal',
  SIMILAR_LISTINGS = 'listing-similar-modal',
  IMAGE_GALLERY = 'image-gallery-modal',
  LISTING_REPORT = 'listing-report-modal',
  AUTOCAN_VIN = 'vinModal',
  SAVE_SEARCH_GUEST = 'save-search-guest-modal',
  MEGA_MENU = 'mega-menu-modal',
  SEARCH_LOCATION = 'search-location-modal',
  SEARCH_FILTERS = 'srp-mobile-filter',
  APP_PEN = 'app-pen-modal',
  COOKIE_CONSENT = 'cookie-consent-modal',

  /** @deprecated */
  MAP = 'genericMapModal',
  REQUEST_VIEWING = 'requestViewing',
}

/**
 * List of modals that should display the authentication modal when user is logged out
 */
export const MODAL_AUTH_REQUIRED: { [x: string]: AuthModalVariant } = {
  [MODAL_REGISTRY.REQUEST_VIEWING]: AuthModalVariant.LoginToRequestViewing,
  [MODAL_REGISTRY.LISTING_FINANCING]: AuthModalVariant.LoginToFinanceInquiry,
}
